module.exports = __webpack_public_path__ + "static/blueTriangle-0c5c874e2635a1d3ba7b908e7de3c13b.png";